/**
 * Grid states — the direction of power flow between a site and the grid.
 *
 * Mirrors the `GridStatus` Prisma enum in `domains/device/prisma/schema.prisma`.
 * `idle` and `unknown` were missing here while being 13–20 % of the observed
 * event stream, so any consumer narrowing to this union rendered them as nothing
 * at all. They need no new Badge entry and no new design token: both names
 * already resolve in `badgeVariantStyles` (declared there under the device-state
 * group, which is a flat map, so a name resolves regardless of which comment
 * group it sits under).
 */
export type GridState = "importing" | "exporting" | "idle" | "unknown";

/**
 * Human-readable labels for grid states
 */
export const gridStateLabels: Record<GridState, string> = {
  importing: "Importing",
  exporting: "Exporting",
  idle: "Idle",
  unknown: "Unknown",
} as const;

/**
 * Get human-readable label for a grid state
 */
export function getGridStateLabel(state: GridState): string {
  return gridStateLabels[state];
}
